import { useParams } from "react-router-dom";
import FormEmpresa from "./formEmpresa";

export function EmpresaVisualizar() {
  const idempresa = useParams();
  return (
    <>
      <div className="container-fluid mt-2">
        <FormEmpresa idempresa={idempresa.id} acao="Visualizar" />
      </div>
    </>
  );
}
